import { t } from 'i18next'
import {
  DEDICS_WITH_6_MONTH_PROMOTION,
  DEDIC_DISPLAY_ORDER,
  dedicPeriods,
} from '../../constants'
import { fetchUrl, isBeforeExpiration, reorderConfigs } from '../../utils'
import { currencyStore } from '../../localization/currency'
import { static_url } from '../../config'
import {
  cutAddonsDisplayValue,
  generateTariffLink,
  getCurrentPeriodTitle,
  openDropdown,
  openPeriodList,
  renderCardsErrorBlock,
  renderPeriodsDropdown,
  // mergePeriodsData,
} from '../../servicesCommonFns'
import {
  copySvgIcon,
  questionIcon,
  shevronIcon,
  labelNewIcon,
  labelSaleIcon,
  shoppingBag,
  calendarPlus,
  renewIcon,
} from '../../icons'

import { createDoubleButton } from '../../components/createDoubleButton'

const DATACENTERS = {
  7: 'netherlands',
  8: 'netherlands',
  16: 'usa',
}

const foundItems = document.querySelector('[data-found-items]')
const copyUrlBtn = document.querySelector('[data-filter-copy]')
const copyUrlTooltip = document.querySelector('[data-filter-copy-tooltip]')

export function copyTariffHandler(btn) {
  const btnElem = btn
  const name = btnElem.getAttribute('data-cpu-name')

  const tooltipText = btn.querySelector('.tooltiptext-dedic')

  tooltipText.classList.add('visible')

  setTimeout(() => tooltipText.classList.remove('visible'), 2000)

  navigator.clipboard.writeText(name)
}
function copyFilterUrl() {
  const url = window.location.href

  copyUrlTooltip.classList.add('visible')
  setTimeout(() => copyUrlTooltip.classList.remove('visible'), 2000)
  navigator.clipboard.writeText(url)
}

copyUrlBtn?.addEventListener('click', copyFilterUrl)

export function fetchDedics(store) {
  return Promise.all([
    fetchUrl(`${process.env.BASE_URL}/v1/api/service/dedic/`),
    // fetchUrl(`${process.env.BASE_URL}/v1/api/service/vds/`),
  ])
    .then(([dedicData]) => {
      const state = store.getState()

      // const RENDER_VDS = {
      //   6322: {
      //     actualPrice: '49.60',
      //     oldPrice: '62.00',
      //     isDiscounted: true,
      //   },
      //   6370: {
      //     actualPrice: '69.00',
      //   },
      // }

      // let vdsTariffs = vdsData.services
      //   .filter(el => Object.keys(RENDER_VDS).includes(String(el.service_id)))
      //   .map(el => {
      //     return { ...el, ...RENDER_VDS[el.service_id], isVds: true }
      //   })

      let dedicServicesWithoutGPU = dedicData?.services?.filter(el => {
        return !el.name?.toLowerCase().includes('nvidia')
      })

      dedicServicesWithoutGPU = cutAddonsDisplayValue(dedicServicesWithoutGPU)

      /** tariffs sorting */

      const sortByPrice = (a, b) => {
        return a?.bill?.price?.[1]?.cost - b?.bill?.price?.[1]?.cost
      }

      const allTariffsPriceSort = dedicServicesWithoutGPU.sort(sortByPrice)

      // set display order
      const allTariffs = isBeforeExpiration('2025-08-28T23:59:59+03:00')
        ? reorderConfigs(allTariffsPriceSort, DEDIC_DISPLAY_ORDER)
        : allTariffsPriceSort
      /** /tariffs sorting */

      /** forming necessary information about tariff */
      allTariffs.forEach(tariff => {
        const splitedName = tariff?.name?.split('/')

        const configName = tariff.specs?.config ?? splitedName[0]?.trim() ?? ''
        const cpu_name =
          tariff.specs?.cpu_name ?? splitedName.find(el => el.includes('Intel'))?.trim() ?? ''

        const traffic = tariff.name.match(/\/ (\d+TB|Unlimited)\s*Traffic/i)?.[1]

        let portSpeed = { item_count: '' }
        if (tariff.isVds) {
          portSpeed.item_count = 1
        } else {
          portSpeed = tariff.addons?.find(el => el.addon_name === 'Port speed')?.item?.[0]
        }

        const cpu =
          tariff.specs?.cpu ??
          splitedName
            .find(el => el.includes('CPU'))
            ?.replace('vCPU', '')
            ?.replace('CPU', '')
            ?.trim() ??
          ''

        const ram =
          tariff.specs?.ram ??
          splitedName.find(el => el.includes('RAM'))?.match(/\d+(?=GB)/gi)?.[0] ??
          ''

        const disk_text =
          tariff.specs?.disk_text ??
          splitedName
            .find(el => el.includes('SSD') || el.includes('NVMe') || el.includes('HDD'))
            ?.trim() ??
          ''

        const hasPeriodDiscounts =
          tariff?.bill?.price && Object.values(tariff.bill.price).some(item => item.percent)

        const isSoldout = !!tariff?.bill?.label?.filter(plist => {
          return (
            dedicData?.flist.find(tagItem => plist.$ === tagItem.$key)?.$?.toLowerCase() ===
            'soldout:true'
          )
        })?.length

        state.dedicTariffsToRender.push(configName)

        const tags = dedicData.flist.filter(plist => {
          return tariff.bill?.label.find(tagItem => plist.$key === tagItem.$)
        })

        const item = {
          ...tariff,
          configName,
          cpu,
          cpu_name,
          disk_text,
          ram,
          traffic,
          'Port speed': portSpeed,
          period: dedicPeriods[0],
          hasPeriodDiscounts,
          service_category: tariff.isVds ? 'vds' : 'dedic',
          isSoldout,
          tags,
        }

        state[configName] = item

        state.tariffs.push(item)
      })

      state.flist = dedicData.flist
      state.selectedCategories = []

      const prices = state.dedicTariffsToRender.map(tariff => state[tariff].bill.price[1].cost)

      state.maxPrice = Math.ceil(Math.max(...prices))

      store.setState(state)
    })
    .catch(e => {
      console.log(e)

      renderCardsErrorBlock({
        text: 'vhost_card_buy_now_btn',
        icon: shoppingBag,
      })

      return Promise.reject()
    })
}

export function createDedicsMarkup(store) {
  const state = store.getState()
  const { filterByActivation, filterByPrice } = state
  const currencyData = currencyStore.getSelectedCurr()
  const exchangeRate = currencyData?.currency

  const desktopHtmlFragment = document.createDocumentFragment()
  const mobileHtmlFragment = document.createDocumentFragment()

  const tariffList = state.filteredTariffs?.length
    ? state.filteredTariffs
    : state.dedicTariffsToRender

  const renderTariffs = tariffList.filter(tariffName => {
    const tariff = state[tariffName]

    const tariffCost = tariff.bill.price[1].cost
    return (
      (filterByPrice
        ? tariffCost >= +filterByPrice[0] && tariffCost <= +filterByPrice[1]
        : true) && (filterByActivation ? tariff.specs.count_exists : true)
    )
  })

  renderTariffs.forEach((tariffName, idx) => {
    const el = state[tariffName]

    const portCost = +el['Port speed'].item_price?.[0]?.cost
    const discountPercent = el?.period?.percent ?? 0
    const portPrice = portCost ? portCost - (portCost * discountPercent) / 100 : 0

    const isSaleTariff = el.tags?.find(tag => tag.$.includes('booleanpromo'))
    const isNewTariff = el.tags?.find(tag => tag.$.includes('booleannew'))

    const isLabel = isSaleTariff || isNewTariff

    const periodPrice = el.bill?.price[el.period.value]
    const periodValue = el?.period?.value ?? 1

    let price = ((portPrice * periodValue + periodPrice?.cost) * exchangeRate).toFixed(2)
    price = Number(price)

    /* setup fee should always have a standard value for all periods */
    const setupFee = (el?.bill?.price?.['1']?.setup_fee * exchangeRate).toFixed(2)

    const baseOldPrice = el?.bill?.price[1].cost

    let oldPrice = Number((portPrice + baseOldPrice) * periodValue * exchangeRate).toFixed(2)

    oldPrice = Number(oldPrice)

    const isDiscounted = oldPrice - price !== 0

    const saving = (oldPrice - price)?.toFixed(2)

    const tariffPeriods = dedicPeriods.map(period => {
      const serverPeriodData = el.bill?.price[period.value]

      return {
        ...period,
        percent: serverPeriodData?.percent || period.percent, // Оновити percent, якщо є в serverData
      }
    })

    const periodTitle = getCurrentPeriodTitle(el)

    const withPromotion =
      DEDICS_WITH_6_MONTH_PROMOTION?.some(id => el.configName.includes(id)) || false

    const dc = DATACENTERS[el?.specs.datacenter?.[0].bill_manager_id]
    const locationImage = `"${static_url}/site/images/dedics/${dc}.svg"`

    const portSpeedSelectMobileMrkp = `
    <!-- ----------- port select ----------- -->
    <button
      class="card_select_btn"
      type="button"
      data-setting="Port speed"
      data-port-selector
      data-tariff-name="${el.configName}"
    >
      ${el['Port speed'].item_count} Gbps${shevronIcon}
    </button>

    <div 
      class="tariff__options-wrapper port"
      data-setting="Port speed"
      data-options-container-${tariffName?.toLowerCase()}
      data-tariff-name="${el.configName}"
    >
      ${renderPortDropdown(el)}
    </div>
    <!-- ----------- End port select ----------- -->`

    const itemElement = document.createElement('li')
    itemElement.classList.add('card_wrapper', 'swiper-slide')

    periodPrice?.percent && itemElement.classList.add('with_discount')
    isDiscounted && itemElement.classList.add('with_discount')

    isNewTariff && itemElement.classList.add('new')
    isSaleTariff && itemElement.classList.add('sale')

    const diskText = el.disk_text?.includes('NVMe')
      ? el.disk_text?.replace(/NVMe/g, '<span class="yellow_highlight">NVMe</span>')
      : el.disk_text?.replace(/\+/g, '+<br>')

    itemElement.setAttribute('style', `z-index: ${100 - idx}`)
    itemElement.innerHTML = `<form
        class="vds-vps__tariff-form ${isSaleTariff || isNewTariff ? 'frame' : ''}"
      >
        <span 
          class="body_s_500 marker saving ${isSaleTariff || isNewTariff ? 'with_label' : ''}"
          ${isDiscounted || periodPrice?.percent ? '' : 'style="display: none"'}
        >
          <span 
            class="tariff__discount-amount" 
            name="discount" 
            id="dedicated-servers__price_${el.service_id}_discount"
          >
            -${currencyData?.symbol}${saving}
          </span>
        </span>
        ${
          isLabel
            ? isSaleTariff
              ? `<span class="card_label">
              ${labelSaleIcon}
              SALE
            </span>`
              : `<span class="card_label new">
                ${labelNewIcon}
              NEW
              </span>`
            : ''
        }

        <div class="tariff_title_wrapper">
          <div class="tariff_title">
            <p class="upper_m">${el.configName}</p>

            <p class="price_font" id="dedicated-servers__price_${el.service_id}_card">
            ${currencyData?.symbol} ${price.toFixed(2)}
            </p>

              ${
                isDiscounted
                  ? `<span class="dedic__card-old-price">
                      ${currencyData?.symbol + oldPrice?.toFixed(0)}${withPromotion ? '*' : ''}
                    </span>`
                  : ''
              }
              <p class="small_text setup_fee">
               + ${t('initial_setup')} ${setupFee ? `${currencyData?.symbol} ${setupFee}` : ''}
              </p>
            ${
              el?.isSoldout
                ? ` <div class="activation_info">
            <div class="soldout_label">
             ${renewIcon}
              sold out
            </div>

           <span class="popup_trigger popup_soldout_trigger">
          ${questionIcon}
          <span class="small_text popup_block dedic_popup_align dedic_soldout_popup_align">${t(
            'dedic_activation_info',
          )}</span>
        </span>
          </div>`
                : `<p class="small_text availability">
                ${el.isVds ? '' : `${t('available')} ${el.specs?.count_exists}${t('pcs')}`}
              </p>`
            }
          </div>
        </div>

        <span class="card_gradient-line"></span>

        <div class="rows-wrapper body_s">
        ${
          el.gpu
            ? `<div class="tariff_parameter_row">
                GPU<span class="tariff_param_value">${el.gpu}</span>
              </div>`
            : ''
        }
        <div class="tariff_parameter_row">
            CPU
            <div class="tariff_value_wrapper">
              <span class="tariff_value_ellipsis tariff_param_value">${el.cpu_name}</span>
              <button data-cpu-name="${
                el.cpu_name
              }" class="tooltip_copy" type="button">${copySvgIcon}
                <span class="body_s tooltiptext-dedic">${t('copy')}</span>
              </button>
            </div>
          </div>
          <div class="tariff_parameter_row">
            ${t('comparison_cores')}
            <span class="tariff_param_value">${el.cpu}</span>
          </div>
          <div class="tariff_parameter_row">
            RAM<span class="tariff_param_value">${el.ram}Gb</span>
          </div>
          <div class="tariff_parameter_row">
            ${t('drive')}
            <span class="tariff_param_value">${diskText}</span>
          </div>
          <div class="tariff_parameter_row">
            ${t('traffic')}
            <span class="tariff_param_value">${el.traffic}</span>
          </div>
          <div class="tariff_parameter_row ${el.traffic === 'Unlimited' && 'dropdown_row'} ">
            ${t('port')}
            ${
              el.traffic === 'Unlimited'
                ? portSpeedSelectMobileMrkp
                : `<span class="tariff_param_value">${el['Port speed'].item_count} Gbps</span>`
            }
          </div>
          <div class="tariff_parameter_row">
            ${t('location')}
            <span class="tariff_value_wrapper tariff_param_value">
            <img class="dedicated-servers__row-icon" width="16px" height="16px" alt=${dc} src=${locationImage} />
            ${t(dc)}</span>
          </div>
          
          <div class="tariff_parameter_row dropdown_row">
            ${t('hight_load_card_period')}
            <!-- ----------- period select ----------- -->
            <button
              class="card_select_btn"
              type="button"
              data-tariff-select="${el.service_id}"
              data-period-selector
              data-period-dedic="1"
              data-tariff-name="${el.configName}"
            >
              ${el?.period?.period} ${t(periodTitle)}
              ${
                periodPrice?.percent
                  ? `<span class="upper_xs tariff__option-percent">${periodPrice?.percent}</span>`
                  : ''
              }
              ${shevronIcon}
            </button>

            <div 
              class="tariff__options-wrapper ${isSaleTariff ? 'tariff__without_sale' : ''}"
              data-period-options-container
              data-tariff-name="${el.configName}"
              id="period_options_${el.service_id}"
            >
              ${renderPeriodsDropdown(tariffPeriods, el.hasPeriodDiscounts, false, true)}
            </div>
            <!-- ----------- End period select ----------- -->
        </div>
      </div>
        ${
          !el?.isSoldout
            ? el.isVds
              ? ''
              : el.specs?.count_exists !== 0
              ? `<p class="activation-time card small_text">${t('dedic_activation_time')}</p>`
              : `<p class="activation-time card small_text">
        ${t('dedic_ready_time')}
        <span class="popup_trigger">
          ${questionIcon}
          <span class="small_text popup_block dedic_popup_align">${t(
            'dedic_activation_info',
          )}</span>
        </span>
      </p>`
            : '<p class="activation-time card small_text"></p>'
        }
      ${createDoubleButton({
        href: generateTariffLink(el),
        mainText: el.specs?.count_exists === 0 ? t('reserve') : t('vhost_card_buy_now_btn'),
        icon: el.specs?.count_exists === 0 ? calendarPlus : shoppingBag,
        className: el.gpu
          ? el.specs?.count_exists === 0
            ? 'reserv_dedicated-gpu'
            : 'buy_dedicated-gpu'
          : el.specs?.count_exists === 0
          ? 'reserv_dedicated'
          : 'buy_dedicated',
      })}
      </form>`

    mobileHtmlFragment.appendChild(itemElement)
  })

  /* /* [data-found-items] does not exist on the dedicated GPU page */
  if (foundItems) {
    foundItems.innerHTML = `${t('found')} ${renderTariffs.length} ${t('pcs')}`
  }

  /** --------------------- EVENT LISTENERS ASSIGNING --------------------- */
  const allPeriodSelects = [desktopHtmlFragment, mobileHtmlFragment].reduce(
    (acc, parentEl) =>
      (acc = [...acc, ...parentEl.querySelectorAll('button[data-period-selector]')]),
    [],
  )

  allPeriodSelects.forEach(btn =>
    btn.addEventListener('click', () => openPeriodList(btn, store)),
  )

  const allPortSelects = [desktopHtmlFragment, mobileHtmlFragment].reduce(
    (acc, parentEl) =>
      (acc = [...acc, ...parentEl.querySelectorAll('button[data-port-selector]')]),
    [],
  )

  allPortSelects.forEach(btn => btn.addEventListener('click', e => openDropdown(e, store)))

  const allCopyBtns = mobileHtmlFragment.querySelectorAll('button[data-cpu-name]')
  allCopyBtns.forEach(btn => btn.addEventListener('click', () => copyTariffHandler(btn)))
  /** --------------------- /EVENT LISTENERS ASSIGNING --------------------- */

  return { mobileFragment: mobileHtmlFragment, desktopFragment: desktopHtmlFragment }
}

function renderPortDropdown(tarrifData) {
  const optionsList = tarrifData.addons.find(el => el.addon_name === 'Port speed')?.item

  let listData = ''
  optionsList?.forEach(el => {
    listData =
      listData +
      `<button
          class="tariff__select-option"
          type="button"
          data-item-id=${el?.item_id}            
        >
          ${el?.item_count} Gbps
        </button>`
  })

  return listData
}
